import * as moment from 'pkp-moment-timezone-all-years';
import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpDateCompareValidator
     * @memberof app
     *
     * @restrict A
     *
     * @description
     * Validates if the ngModel date is smaller/bigger/equals another date
     *
     * @attr {Date} ngModel
     * @attr {Date} compareDate Date with ngModel is compared to
     * @attr {string} comparison Comparison sign, {===,>,<,>=,<=,!==}
     * @attr {boolean} dateCompareActive if the validator if active (if false, the validator will be always valid)
     *
     * @author somarten.btc
     */
    angular
        .module('app')
        .directive('pkpDateCompareValidator', pkpDateCompareValidator);

    function pkpDateCompareValidator() {
        return {
            restrict: 'A',
            scope: false,
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            ngModelCtrl.$validators.pkpDateCompareValidator = validate;

            function validate(modelValue) {
                var comparison = attr.comparison;
                var comparison2 = attr.comparison2;
                var compareDate = scope.$eval(attr.compareDate);
                var compareDate2 = scope.$eval(attr.compareDate2);
                var active = scope.$eval(attr.dateCompareValidatorActive);

                if (!modelValue || !comparison || !active || !compareDate) {
                    return true;
                }

                if (!comparison2 || !compareDate2) {
                    return checkDate(modelValue, compareDate, comparison);
                } else {
                    return (
                        checkDate(modelValue, compareDate, comparison) &&
                        checkDate(modelValue, compareDate2, comparison2)
                    );
                }
            }

            function checkDate(modelValue, date, comparison) {
                switch (comparison) {
                    case '===': {
                        return moment(modelValue).isSame(date);
                    }
                    case '!==': {
                        return !moment(modelValue).isSame(date);
                    }
                    case '>=': {
                        return (
                            moment(modelValue).isSame(date) ||
                            moment(modelValue).isAfter(date)
                        );
                    }
                    case '>': {
                        return moment(modelValue).isAfter(date);
                    }
                    case '<=': {
                        return (
                            moment(modelValue).isSame(date) ||
                            moment(modelValue).isBefore(date)
                        );
                    }
                    case '<': {
                        return moment(modelValue).isBefore(date);
                    }
                }
            }

            scope.$watch(
                function () {
                    return scope.$eval(attr.compareDate);
                },
                function () {
                    ngModelCtrl.$validate();
                },
                true
            );

            scope.$watch(
                function () {
                    return scope.$eval(attr.compareDate2);
                },
                function () {
                    ngModelCtrl.$validate();
                },
                true
            );

            scope.$watch(
                function () {
                    return scope.$eval(attr.dateCompareValidatorActive);
                },
                function () {
                    ngModelCtrl.$validate();
                }
            );
        }
    }
})();
